import {
  changeStatus,
  getBidderCardList,
  getLatestPrice,
  getOffer,
  getOfferForEditView,
  participateBidder,
  sendDocumentBidder,
  downloadExcelOrigin,
  downloadExcelModified,
  downloadPDFProtocol,
  downloadPDFProtocols,
} from '@/http/offer/offerApi'
import { createFormDataNewFiles } from '@/utils/files'

export class BiddingProcedureService {
  async getLastPrice(lotId) {
    const { data } = await getLatestPrice(lotId)
    return data
  }

  async getBidderCardList(lotId) {
    const { data } = await getBidderCardList(lotId)
    return data
  }

  async participateBidder(formData, list) {
    const data = {
      lot: formData,
      offers: list,
    }
    return await participateBidder(data)
  }

  async sendBidderDocuments(lotId, files, sort) {
    const data = createFormDataNewFiles(files, { sort })
    if (!data) return

    return await sendDocumentBidder(lotId, data)
  }

  async getOfferForEditView(lotId, userId, sort, isFake) {
    return await getOfferForEditView(lotId, userId, sort, isFake)
  }

  async sendResultStatus(lotId, status) {
    return await changeStatus(lotId, status)
  }

  async getCardList(lotId) {
    const { data } = await getOffer(lotId)
    return data || []
  }

  async downloadExcelResultOrigin(lotId) {
    const { data } = await downloadExcelOrigin(lotId)
    window.open(data.data)
  }

  async downloadExcelResultModified(lotId) {
    const { data } = await downloadExcelModified(lotId)
    window.open(data.data)
  }

  async downloadPDFProtocolResult(resultId) {
    const { data } = await downloadPDFProtocol(resultId)
    window.open(data.data)
  }

  async downloadPDFProtocolsResults(resultIds) {
    const { data } = await downloadPDFProtocols(resultIds)
    window.open(data.data)
  }
}
